import { accountLinkProposalSchema } from '@/shared/types/sign/account-link';
import { NextIntlTranslationsType } from '@/shared/types/global/next-intl';
import { referralBenefitResultSchema } from '@/shared/types/sign/referral-benefit';
import { z } from 'zod';

const passwordRegex =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])[A-Za-z\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{8,}$/;

export const signUpSchema = (t: NextIntlTranslationsType) => {
  return z
    .object({
      id: z
        .string()
        .min(1, { message: t('Validation.email-required') })
        .email({ message: t('Validation.email-format') }),
      name: z
        .string()
        .min(1, { message: t('Validation.name-required') })
        .max(15, { message: t('Validation.max-length') })
        .regex(/^[A-Za-z가-힣\s]+$/, {
          message: t('Validation.format'),
        }),
      password: z
        .string()
        .min(1, { message: t('Validation.password-required') })
        .min(8, { message: t('Validation.password-min-length') })
        .regex(passwordRegex, {
          message: t('Validation.password-format'),
        }),
      passwordCheck: z
        .string()
        .min(1, { message: t('Validation.password-required') })
        .min(8, { message: t('Validation.password-min-length') }),
      code: z.string(),
      type: z.string(),
      key: z.string(),
      industry: z
        .object({
          id: z.string(),
          label: z.string(),
          selected: z.boolean(),
        })
        .array(),
      industryDescription: z.string().optional(),
      job: z
        .object({
          id: z.string(),
          label: z.string(),
          selected: z.boolean(),
        })
        .array(),
      jobDescription: z.string().optional(),
      referralCode: z.string().optional(),
    })
    .refine((data) => data.password === data.passwordCheck, {
      message: t('Validation.password-mismatch'),
      path: ['passwordCheck'], // passwordConfirm 필드에 에러 메시지를 연결
    });
};

export const signUpResSchema = z.object({
  accessToken: z.string().nullable().optional(),
  refreshToken: z.string().nullable().optional(),
  referralBenefitResult: referralBenefitResultSchema.nullable().optional(),
  linkProposal: accountLinkProposalSchema.nullable().optional(),
});

export type SignUpFormType = z.infer<ReturnType<typeof signUpSchema>>;
export type SignUpResType = z.infer<typeof signUpResSchema>;

export const ISSUE_FAIL_REASON = {
  COUPON_MAX_EXCEEDED: 1,
  POINT_ISSUE_FAILED: 2,
  REFERRAL_PERIOD_EXPIRED: 3,
} as const;
